import React, { useState } from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import { makeStyles } from '@material-ui/core/styles';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';

import { Create, Add, BeenhereRounded } from '@material-ui/icons';

import Button from 'components/CustomButtons/Button.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTable.js';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

import { useModal } from 'hooks/useModal';
import { Toasty, useToasty } from 'hooks/Toasty';
import ButtonDelete from 'hooks/ButtonDelete';
import { WithApp } from 'contexts/appContext';
import FilterCustom from 'components/Tvendo/Common/FilterCustom';
import { wsFindBy } from 'services/WService';
import ModalQuotaZone from './Modal';
import { currency } from 'hooks/Pipe';

const useStyles = makeStyles({
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  }
});

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 130 },
  { Header: 'Fec. Periodo', accessor: 'period_date', width: 140 },
  { Header: 'Básico', accessor: 'quota', width: 140 },
  { Header: 'Básico 2', accessor: 'quota_2', width: 140 },
  { Header: 'T. comisión', accessor: 'type', width: 140 },
  { Header: 'Cód. Jefe', accessor: 'staff_code', width: 140 },
  { Header: 'Nombre Jefe', accessor: 'staff_name' },
  { Header: 'Zona', accessor: 'base_zone_description', width: 120 },
  { Header: 'Estado', accessor: 'state', width: 100 },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 }
];

export default WithApp(function QuotaZone(props) {
  const classes = useStyles();
  const [model, setOpen] = useModal();
  const [notify, showNotify] = useToasty();

  const [quotaZones, setQuotaZones] = useState([]);

  const [filter, setFilter] = useState(undefined);
  const [dataLoading, setDataLoading] = useState(false);

  async function listQuotaZones(filter) {
    setFilter(filter);

    for (let clave in filter) {
      if (filter[clave] == null || filter[clave] == '') {
        delete filter[clave];
      }
    }

    setDataLoading(true);
    let response = await wsFindBy('com/zone-quota', filter);
    setDataLoading(false);
    if (response.success) setQuotaZones(response.data);
  }

  return (
    <>
      <Toasty action={notify} />
      <ModalQuotaZone
        model={model}
        setOpen={setOpen}
        showNotify={showNotify}
        reload={() => listQuotaZones(filter)}
      />
      <Card>
        <CardHeader icon>
          <AllowedGuard
            permission={ConstantPermissions.COM_ZONE_QUOTAS_STORE}
            component={
              <CardIcon color="primary">
                <BeenhereRounded style={{ color: 'white' }} />
              </CardIcon>
            }
          >
            <CardIcon
              onClick={() => setOpen({})}
              pointer="true"
              color={props.themeContext.buttonColorSuccess}
            >
              <Add />
            </CardIcon>
          </AllowedGuard>
          <h4 className={classes.cardIconTitle}>Listado de comisiones básicas {dataLoading && <LoadingSpinner />}</h4>
        </CardHeader>
        <CardBody>
          <FilterCustom
            getFilter={listQuotaZones}
            date
            dateType="month"
            labelDate="Periodo"
            dateField="period_date"
            zone
            jefe
            commissions={[
              { key: 'R', label: 'Jefe reparto' },
              { key: 'M', label: 'Encargado mercadería' },
              { key: 'S', label: 'Supervisor' }
            ]}
            commissionField="type"
          />

          <ReactTable
            excelName="Cuota_por_zona"
            formatDate="DD-MM-YYYY"
            defaultWidth={1200}
            columns={columns}
            data={quotaZones.map((item, i) => {
              let commission = '-';

              switch (item.type) {
                case 'R':
                  commission = 'Jefe reparto';
                  break;
                case 'M':
                  commission = 'Encargado mercadería';
                  break;
                case 'S':
                  commission = 'Supervisor';
                  break;
                default:
                  commission = '-';
                  break;
              }

              return {
                num: (
                  <div className="actions-right">
                    {i + 1}
                    <AllowedGuard permission={ConstantPermissions.COM_ZONE_QUOTAS_UPDATE}>
                      <Button justIcon round simple color="info" onClick={() => setOpen(item)}>
                        <Create />
                      </Button>
                    </AllowedGuard>
                    <AllowedGuard permission={ConstantPermissions.COM_ZONE_QUOTAS_DELETED}>
                      <ButtonDelete
                        entity="com/zone-quota"
                        id={item.id}
                        reload={() => listQuotaZones(filter)}
                      />
                    </AllowedGuard>
                  </div>
                ),
                period_date: item.period_date,
                quota: currency(item.quota),
                quota_2: currency(item.quota_2),
                type: commission,
                staff_code: item.staff_code,
                staff_name: item.staff_name,
                base_zone_description: `${item.base_zone_code || ''} - ${
                  item.base_zone_description || ''
                }`,
                state: item.state === 'A' ? 'Activo' : 'Inactivo',
                actions: ''
              };
            })}
          />
        </CardBody>
      </Card>
    </>
  );
});
